import React from 'react';
import { Filter, TextInput, ReferenceInput, SelectInput, BooleanInput } from 'react-admin';

const CustomFilterCustomer = (props) => (
  <Filter {...props}>
    <TextInput label="Procurar..." source="q" alwaysOn />
    <ReferenceInput source="campaign_id" label="Campanha" reference="setup/campaigns" alwaysOn >
      <SelectInput optionText="name" optionValue="id" />
    </ReferenceInput>
    <BooleanInput source="active" label="Ativo(s)" alwaysOn />
  </Filter>
)

export default CustomFilterCustomer;
